<template>
  <div class="hello">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
      >{{ msg }}</modal
    >

    <modal height="auto" classes="qr-modal" width="300px" name="qr">
      <img :src="qrImgUrl" alt />
      <h3>请使用微信扫码支付</h3>
    </modal>

    <div>
      <img class="tp-logo" alt="TokenPocket logo" src="../assets/logo.png" />

      <span class="lang-switch">
        <a
          v-if="this.$i18n.locale === 'zh'"
          @click="changeLang('en')"
          href="javascript:;"
          >En</a
        >
        <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
      </span>
    </div>

    <ul class="blockchain">
      <li :class="currentBc === 'eos' ? 'active' : ''" @click="changeBc('eos')">
        <i class="iconfont icon-eos"></i>
        <br />EOS
      </li>
      <!-- <li :class="currentBc === 'bos' ? 'active': ''" @click="changeBc('bos')">
        <i class="iconfont icon-bos"></i>
        <br />BOS
      </li> -->
      <li
        :class="currentBc === 'iost' ? 'active' : ''"
        @click="changeBc('iost')"
      >
        <i class="iconfont icon-iost"></i>
        <br />IOST
      </li>
    </ul>
    <div class="card">
      <h2>{{ $t("i18nView.activitionCode") }}</h2>
      <div v-if="!isResult" class="price">{{ currPrice }}</div>
      <div v-else class="code">{{ code }}</div>
      <div v-if="currentBc === 'eos'" class="config">
        <span>
          0.5 EOS
          <br />CPU
        </span>
        <span>
          0.01 EOS
          <br />NET
        </span>
        <span>
          4.0 KB
          <br />RAM
        </span>
      </div>
      <!-- <div v-else-if="currentBc === 'bos'" class="config">
        <span>
          0.5 BOS
          <br />CPU
        </span>
        <span>
          0.01 BOS
          <br />NET
        </span>
        <span>
          4.0 KB
          <br />RAM
        </span>
      </div> -->
      <div v-else-if="currentBc === 'iost'" class="config config-iost">
        <span>
          1.0 KB
          <br />RAM
        </span>
        <span>
          10 IOST
          <br />GAS
        </span>
      </div>
    </div>
    <div class="align-center">
      <button v-if="isResult && isSupportCopy" class="copy-btn">
        {{ $t("i18nView.copyCode") }}
        <i class="iconfont icon-copy"></i>
      </button>
    </div>

    <div class="payment" v-if="!isResult">
      <h3>{{ $t("i18nView.payment") }}</h3>
      <ul class="payment-ul">
        <li
          :class="currPayment === 'alipay' ? 'active' : ''"
          @click="changePayment('alipay')"
        >
          <i class="iconpng icon-alipay"></i>
          <span>{{ $t("i18nView.alipay") }}</span>
        </li>
        <li
          :class="currPayment === 'weixin' ? 'active' : ''"
          @click="changePayment('weixin')"
        >
          <i class="iconpng icon-weixin"></i>
          <span>{{ $t("i18nView.weipay") }}</span>
        </li>
        <li
          v-if="isPaypalAvaileble"
          :class="currPayment === 'paypal' ? 'active' : ''"
          @click="changePayment('paypal')"
        >
          <i class="iconpng icon-paypal"></i>
          <span>Paypal</span>
        </li>
      </ul>
    </div>
    <div class="receiver" v-if="!isResult">
      <div class="receiver-lable">
        <span class="receiver-span">{{ $t("i18nView.reciveMethod") }}:</span>
        <label
          @click="changeMethod('phone')"
          :class="currentMethod === 'phone' ? 'active' : ''"
          for
          >{{ $t("i18nView.phone") }}</label
        >
        |
        <label
          @click="changeMethod('email')"
          :class="currentMethod === 'email' ? 'active' : ''"
          for
          >{{ $t("i18nView.email") }}</label
        >
      </div>
      <div class="input-wrap" v-if="currentMethod === 'phone'">
        <select name="area" v-model="currentArea" id="area">
          <option v-for="item in countryList" :value="item.code">
            {{ item.name + item.code }}
          </option>
        </select>
        <div class="phone-wrap">
          <input
            id="phone"
            v-model="phoneInput"
            type="text"
            :placeholder="$t('i18nView.phoneholder')"
          />
        </div>
      </div>
      <div class="input-wrap" v-else>
        <i class="iconfont icon-mail"></i>
        <div class="mail-wrap">
          <input
            id="email"
            v-model="mailInput"
            type="text"
            :placeholder="$t('i18nView.emailholder')"
          />
        </div>
      </div>
    </div>

    <!-- <div class="confirm" v-if="!isResult">
      <div v-if="currPayment === 'paypal'" id="paypal-button-container"></div>
      <div v-else>
        <button @click="confirm()" class="button">
          {{ $t("i18nView.paynow") }}
        </button>
        <hr />

        <div v-if="currentBc === 'eos'" class="more">
          <h3>{{ $t("i18nView.moreOptions") }}</h3>
          <p>
            <span @click="confirm('39.90')" style="margin-right: 9%"
              >{{ $t("i18nView.optionOne") }}: ￥39.9</span
            >
            <span @click="confirm('59.90')"
              >{{ $t("i18nView.optionTwo") }}: ￥59.9</span
            >
          </p>
          <p class="tips align-center">{{ $t("i18nView.optionTips") }}</p>
          <hr />
        </div>
      </div>

      <p v-if="currentBc !== 'iost'" class="tips">
        {{ $t("i18nView.accountTips") }} {{ currentBc.toUpperCase() }}
        {{ $t("i18nView.accountTips2") }} {{ currentBc.toUpperCase() }}
        {{ $t("i18nView.accountTips3") }} {{ currentBc.toUpperCase() }}
        {{ $t("i18nView.accountTips4") }}
      </p>

      <p>
        <a
          class="links"
          target="_blank"
          :href="
            this.$i18n.locale === 'zh'
              ? 'https://help.mytokenpocket.vip/hc/zh-cn/articles/900001863646--%E4%B8%BA%E4%BB%80%E4%B9%88%E5%9C%A8TP%E9%92%B1%E5%8C%85%E5%88%9B%E5%BB%BAEOS-BOS-IOST%E8%B4%A6%E5%8F%B7%E9%9C%80%E8%A6%81%E4%BB%98%E8%B4%B9-'
              : 'https://help.mytokenpocket.vip/hc/en-001/articles/900001863646-Why-it-s-a-paid-service-to-create-an-EOS-BOS-IOST-account-on-TokenPocket'
          "
          >{{ $t("i18nView.whypaid") }}</a
        >
      </p>
    </div> -->

    <a href="javascript:void(0)" class="button normal">{{
      $t("i18nView.paused")
    }}</a>

    <a href="https://tokenpocket.pro/" target="_blank" class="button normal"
      >{{ $t("i18nView.download") }} TokenPocket</a
    >

    <button class="button normal" @click="goBuyAgain()" v-if="isResult">
      {{ $t("i18nView.buyAgain") }}
    </button>
  </div>
</template>


<script>
import account from "./account";

export default account;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.hello {
  padding: 10px 16px 40px;
  background-image: url("../assets/top-bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100%;
  position: relative;
  z-index: 10;
}

.tp-logo {
  height: 27.5px;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 10px 0 20px;

  li {
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    user-select: none;
  }
}

.card {
  box-sizing: border-box;

  border-radius: 10px;
  padding: 15px;
  background-color: #2999fe;
  background-image: url("../assets/card-bg.png");
  background-size: 100% 100%;
  color: #fff;
  box-shadow: 0px 10px 20px 0px #add8ff;

  h2 {
    text-align: center;
    font-weight: normal;
    font-size: 16px;
    margin: 0 0 10px;
  }

  .price,
  .code {
    min-height: 50px;
    line-height: 50px;
    font-size: 32px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .config {
    span {
      display: inline-block;
      width: 30%;
      margin: 0 1.5%;
      text-align: center;
      font-size: 12px;
    }
  }

  .config-iost {
    span {
      width: 46%;
    }
  }
}

ul.blockchain li {
  width: 48%;
  margin-right: 4%;
  padding: 6px 20px;
  border-radius: 8px;
  font-size: 13px;
  color: #999;

  .iconfont {
    font-size: 26px;
  }

  &.active {
    color: #000;
    background: #fff;
    box-shadow: 0 1px 8px 0 #e9e9e9;
  }

  &:last-child {
    margin-right: 0;
  }
}
.payment {
  width: 95%;
  text-align: center;
  font-size: 14px;
  margin: 40px auto 10px;
}
ul.payment-ul li {
  width: 30%;
  margin-right: 4%;
  padding: 10px 4px;
  border-radius: 8px;
  font-size: 13px;
  border: 1px solid #e7e9ec;

  i,
  span {
    vertical-align: middle;
  }

  &.active {
    border: 1px solid #2980fe;
    border-radius: 6px;
    box-shadow: 0 1px 8px 0 #e9e9e9;
  }

  &:last-child {
    margin-right: 0;
  }
}

.iconpng {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 4px;
}

.icon-weixin {
  background-image: url("../assets/Slice2.png");
}

.icon-alipay {
  background-image: url("../assets/alipay.png");
}

.icon-paypal {
  background-image: url("../assets/Slice.png");
}

.receiver {
  margin-top: 30px;
}

.receiver-lable {
  font-size: 14px;
  margin: 10px 0;

  .receiver-span {
    margin-right: 10px;
  }
  label {
    color: #999;
    padding: 0 4px;

    &.active {
      color: #000;
    }
  }
}

.input-wrap {
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #e7e9ec;
  color: #666;
  position: relative;
}

#email,
#phone {
  -webkit-appearance: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  font-size: 13px;
  padding: 8px;
  outline: none;
  border: 1px solid transparent;
  background: transparent;
}

.mail-wrap {
  padding-left: 40px;
}

.icon-copy {
  font-size: 14px;
  vertical-align: middle;
}

.icon-mail {
  position: absolute;
  font-size: 18px;
  left: 14px;
  top: 11px;
}

.phone-wrap {
  padding-left: 90px;
}

.tips {
  margin: 10px 0;
  color: #999;
  font-size: 13px;
}

#area {
  position: absolute;
  width: 90px;
  font-size: 13px;
  left: 4px;
  top: 0;
  padding: 10px 4px;
  display: block;
  // border: none;
  border: 1px solid transparent;
  -webkit-appearance: none;
  background: transparent;
}

.links {
  font-size: 13px;
  color: #2980fe;
  text-decoration: none;
}

.more {
  text-align: center;
  overflow: hidden;

  h3 {
    color: #333;
    font-size: 14px;
  }

  span {
    display: inline-block;
    padding: 8px;
    border: 1px solid #2980fe;
    font-size: 13px;
    color: #2980fe;
    box-sizing: border-box;
    border-radius: 4px;
    width: 45%;
  }
}

.align-center {
  text-align: center;
}

.confirm {
  margin: 20px 0;

  hr {
    margin: 20px 0 10px;
    transform: scaleY(0.5);
    border: none;
    border-bottom: 1px solid #e7e9ec;
  }

  button.button {
    width: 100%;
    padding: 10px;
    font-size: 15px;
    background-color: #2980fe;
    color: #fff;
    border: none;
    border-radius: 8px;
    outline: none;
  }
}

.copy-btn {
  padding: 8px 12px;
  margin: 16px auto;
  color: #fff;
  background-color: #48a2fc;
  border-radius: 8px;
  border: none;
  outline: none;
}

.button.normal {
  display: block;
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  width: 100%;
  padding: 10px;
  font-size: 15px;
  border: 1px solid #2980fe;
  border-radius: 8px;
  background: #fff;
  color: #2980fe;
  outline: none;
  margin-top: 20px;
}

.msg-modal {
  background: #f6f6f6;
  padding: 20px;
  box-shadow: 0 2px 10px 0 #aaaaaa;
  text-align: center;
  border-radius: 2px;
}

.qr-modal {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
}

.lang-switch {
  float: right;
  display: inline-block;
  font-weight: bold;
}

.lang-switch a {
  display: inline-block;
  padding: 1px 8px;
  font-size: 12px;
  text-decoration: none;
  color: #2cadff;
  border: 1px solid #2cadff;
  border-radius: 100px;
}

a,
body {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  // -moz-user-focus: none;
}
</style>
